<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="info">
    <div class="content" style="height: 345px">
      <el-steps direction="vertical" :active="stepsNum" class="steps">
        <el-step title=""> </el-step>
        <el-step title=""></el-step>
        <el-step title=""></el-step>
        <el-step title=""></el-step>
        <el-step title=""></el-step>
      </el-steps>
      <div class="right">
        <div class="content-item">
          <div>
            <p>主体资料</p>
            <p style="color: #999">请填写商家的营业执照/登记证书、经营者/法人的证件等信息</p>
          </div>
          <div>
            <el-button v-if="!typeList.includes('subject')" type="text" @click="subjectInfo">去填写</el-button>
            <el-button v-if="typeList.includes('subject')" class="finish" type="text" @click="subjectInfo"
              >已完成</el-button
            >
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="content-item">
          <div>
            <p>经营资料</p>
            <p style="color: #999">请填写商家的经营业务信息、售卖商品/提供服务场景信息</p>
          </div>
          <div>
            <el-button v-if="!typeList.includes('business')" type="text" @click="operateInfo">去填写</el-button>
            <el-button v-if="typeList.includes('business')" class="finish" type="text" @click="operateInfo"
              >已完成</el-button
            >
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="content-item">
          <div>
            <p>结算规则</p>
            <p style="color: #999">请填写商家的结算费率规则、特殊资质等信息</p>
          </div>
          <div>
            <el-button v-if="!typeList.includes('settlementRules')" type="text" @click="settlementRule"
              >去填写</el-button
            >
            <el-button v-if="typeList.includes('settlementRules')" class="finish" type="text" @click="settlementRule"
              >已完成</el-button
            >
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="content-item">
          <div>
            <p>结算银行账户</p>
            <p style="color: #999">请填写商家提现收款的银行账户信息</p>
          </div>
          <div>
            <el-button v-if="!typeList.includes('settlementBank')" type="text" @click="bankInfo">去填写</el-button>
            <el-button v-if="typeList.includes('settlementBank')" class="finish" type="text" @click="bankInfo"
              >已完成</el-button
            >
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="content-item last">
          <div>
            <p>超级管理员信息</p>
            <p style="color: #999">
              请填写商家的超级管理员信息，
              超级管理员需在开户后进行签约，并接收日常重要管理信息和进行资金操作，请确定其为商户法定代表人或负责人
            </p>
          </div>
          <div>
            <el-button v-if="!typeList.includes('superAdministrator')" type="text" @click="SuperAdminInfo"
              >去填写</el-button
            >
            <el-button v-if="typeList.includes('superAdministrator')" class="finish" type="text" @click="SuperAdminInfo"
              >已完成</el-button
            >
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    typeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      stepsNum: 1,
    };
  },

  watch: {
    typeList: {
      handler: function (typeList) {
        console.log(typeList);
        if (typeList.includes('subject')) {
          this.stepsNum = 1;
        }
        if (typeList.includes('business')) {
          this.stepsNum = 2;
        }
        if (typeList.includes('settlementRules')) {
          this.stepsNum = 3;
        }
        if (typeList.includes('settlementBank')) {
          this.stepsNum = 4;
        }
        if (typeList.includes('superAdministrator')) {
          this.stepsNum = 5;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
    type() {
      return this.$route.query.type;
    },
  },
  methods: {
    subjectInfo() {
      this.$router.push({
        path: '/merchants/subjectInfo',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    operateInfo() {
      this.$router.push({
        path: '/merchants/operateInfo',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    settlementRule() {
      this.$router.push({
        path: '/merchants/settlementRule',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    bankInfo() {
      this.$router.push({
        path: '/merchants/bankInfo',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    SuperAdminInfo() {
      this.$router.push({
        path: '/merchants/SuperAdminInfo',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info {
  box-sizing: border-box;
  padding: 18px 30px 80px 30px;
  .content {
    display: flex;
    justify-content: flex-start;
  }
  .steps {
    margin-top: 10px;
  }
  .right {
    width: 100%;
    .finish {
      color: #2ba33a;
    }
  }
  .last {
    border-bottom: 1px solid #e5e5e5;
  }
  .content-item {
    height: 80px;
    border-top: 1px solid #e5e5e5;
    box-sizing: border-box;
    padding: 14px 14px 22px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      font-size: 12px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }
    .el-icon-arrow-right {
      margin-left: 15px;
    }
  }
}
</style>
